var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L40 0L40 40L0 40L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "aviso"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L40 0L40 40L0 40L0 0Z",
    id: "Fondo",
    fill: "#FFFFFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(3.75 3.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5 0L5 0C2.23858 0 0 2.23858 0 5L0 22.75C0 25.5114 2.23858 27.75 5 27.75L10.65 27.75L13.3188 31.0887C14.0303 31.9805 15.1091 32.4999 16.25 32.4999C17.3909 32.4999 18.4697 31.9805 19.1813 31.0888L21.85 27.75L27.5 27.75C30.2614 27.75 32.5 25.5114 32.5 22.75L32.5 5C32.5 2.23858 30.2614 1.19209e-06 27.5 1.19209e-06L27.5 0ZM30 22.75C30 24.1307 28.8807 25.25 27.5 25.25L21.25 25.25C20.8701 25.2502 20.5108 25.4231 20.2738 25.72L17.2275 29.5263C16.9824 29.8108 16.6255 29.9745 16.25 29.9745C15.8745 29.9745 15.5176 29.8108 15.2725 29.5263L12.2262 25.72C11.9892 25.4231 11.6299 25.2502 11.25 25.25L5 25.25C3.61929 25.25 2.5 24.1307 2.5 22.75L2.5 5C2.5 3.61929 3.61929 2.5 5 2.5L27.5 2.5C28.8807 2.5 30 3.61929 30 5L30 22.75ZM26.25 8.75C26.25 9.44036 25.6904 10 25 10L7.5 10C7.05342 10 6.64076 9.76175 6.41747 9.375C6.19418 8.98825 6.19418 8.51175 6.41747 8.125C6.64076 7.73825 7.05342 7.5 7.5 7.5L25 7.5C25.6904 7.5 26.25 8.05964 26.25 8.75L26.25 8.75ZM26.25 13.75C26.25 14.4404 25.6904 15 25 15L7.5 15C7.05342 15 6.64076 14.7618 6.41747 14.375C6.19418 13.9883 6.19418 13.5118 6.41747 13.125C6.64076 12.7382 7.05342 12.5 7.5 12.5L25 12.5C25.6904 12.5 26.25 13.0596 26.25 13.75L26.25 13.75ZM26.25 18.75C26.25 19.4404 25.6904 20 25 20L7.5 20C7.05342 20 6.64076 19.7618 6.41747 19.375C6.19418 18.9882 6.19418 18.5118 6.41747 18.125C6.64076 17.7382 7.05342 17.5 7.5 17.5L25 17.5C25.6904 17.5 26.25 18.0596 26.25 18.75L26.25 18.75Z",
    id: "Forma",
    fill: "#10B48C",
    fillRule: "evenodd",
    stroke: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.8abc7e0b56f61215ee4a57fa0c393ad3.svg";
export { ForwardRef as ReactComponent };